import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Avatar, Badge, Dropdown, Typography } from "antd";
import {
	FiGrid, FiTarget, FiBell, FiUser, FiLock, FiLogOut,
	FiChevronDown, FiCreditCard, FiLayers,
} from "react-icons/fi";
import Menu from "../Menu";
import { SOCIAL_LINKS } from "../../../contstants/VaribaleConstant";
import MobileMenu from "../MobileMenu";
import { useDispatch, useSelector } from "react-redux";
import { resetAuth } from "../../../store/slices/AuthSlice";
import { resetMember } from "../../../store/slices/MemberSlice";
import { resetUtility } from "../../../store/slices/UtilitySlice";
import { setFileUrl } from "../../../helpers/FormHelper";
import { getCapitalizedString } from "../../../helpers/StringFormatHelper";
import { FaStar } from "react-icons/fa";

const { Text } = Typography;

function initialsOf(name = "") {
	const parts = String(name).trim().split(/\s+/).slice(0, 2);
	return parts.map(p => p[0]?.toUpperCase()).join("") || "U";
}

export default function Header1({ scroll, handleLogin }) {
	const unreadCount = 0;
	const currentUser = useSelector((state) => state.Member.data);
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const onLogout = () => {
		dispatch(resetAuth());
		dispatch(resetMember());
		dispatch(resetUtility());
		navigate("/");
	};

	const items = [
		{ key: "dash", icon: <FiGrid />, label: <Link to="/dashboard">Dashboard</Link> },
		{ key: "pred", icon: <FiTarget />, label: <Link to="/my/predictions">My predictions</Link> },
		{
			key: "notif",
			icon: (
				<Badge size="small" count={unreadCount} offset={[8, -2]}>
					<FiBell />
				</Badge>
			),
			label: <Link to="/notifications">Notifications</Link>,
		},
		{ type: "divider" },
		{ key: "profile", icon: <FiUser />, label: <Link to="/account/profile">My profile</Link> },
		{ key: "billing", icon: <FiCreditCard />, label: <Link to="/account/billing">Billing</Link> },
		{ key: "plans", icon: <FiLayers />, label: <Link to="/plans">Plans & Pricing</Link> },
		{ key: "pwd", icon: <FiLock />, label: <Link to="/account/security">Change password</Link> },
		{ type: "divider" },
		{ key: "logout", danger: true, icon: <FiLogOut />, label: "Logout" },
	];

	const onMenuClick = ({ key }) => {
		if (key === "logout") {
			onLogout?.();
			return;
		}
		const routes = {
			dash: "/dashboard",
			pred: "/my/predictions",
			notif: "/notifications",
			profile: "/account/profile",
			billing: "/account/billing",
			plans: "/plans",
			pwd: "/account/security",
		};
		if (routes[key]) navigate(routes[key]);
	};

	return (
		<>
			<div className="header-top">
				<div className="themeflat-container">
					<div className="header-top-inner">
						<div className="address">
							<Link to="mailto:info@predixio.io"><i className="icon-Vector" />info@predixio.co</Link>
							<address><i className="icon-Vector-22" />Uwe-Seeler-Allee 9 22525 Hamburg</address>
						</div>
						<div className="address" />
						<div className="social-icon">
							<Link to={SOCIAL_LINKS.facebook} target="_blank"><i className="icon-facebook" /></Link>
							<Link to={SOCIAL_LINKS.instagram} target="_blank"><i className="icon-instagram" /></Link>
							<Link to={SOCIAL_LINKS.twitter} target="_blank"><i className="icon-twitter" /></Link>
							<Link to={SOCIAL_LINKS.youtube} target="_blank"><i className="icon-youtube" /></Link>
						</div>
					</div>
				</div>
			</div>

			<header id="header" className={`header style1 clearfix ${scroll ? "downscrolled" : ""}`}>
				<div className="themeflat-container">
					<div className="header-inner px-header">
						<div className="mm-slot">
							<MobileMenu headerSelector="#header" />
						</div>

						<div id="logo" className="logo">
							<Link to="/" rel="home">
								<img id="a2" src="/images/predixio.svg" style={{ width: '150px' }} alt="logo" className="px-logo" />
							</Link>
						</div>

						<div className="nav-wrap">
							<nav id="mainnav" className="mainnav">
								<Menu />
							</nav>
						</div>

						<div className="header-right">
							{currentUser ? (
								<Dropdown trigger={["click"]} menu={{ items, onClick: onMenuClick }} placement="bottomRight">
									<div className="px-userchip" role="button" tabIndex={0}>
										<Badge dot={unreadCount > 0}>
											<Avatar
												size={36}
												src={setFileUrl(currentUser.photo)}
												alt={currentUser.fullName}
												style={{ backgroundColor: "#1e40af" }}
											>
												{!currentUser.avatarUrl && initialsOf(currentUser.fullName)}
											</Avatar>
										</Badge>
										<div className="px-usertext">
											<Text className="px-username" ellipsis strong>
												{currentUser.fullName}
											</Text>
											<Text className="px-useremail" type="secondary" ellipsis>
												{currentUser.subscriptionType === 'free' ? (
													<>
														{getCapitalizedString(currentUser.subscriptionType)} Tier - <FaStar style={{ marginTop: -3, color: '#004aad' }} /> <span style={{ color: '#004aad' }}>{currentUser.freeTokens}</span>
													</>
												) : (
													<>{getCapitalizedString(currentUser.subscriptionType)} Tier - <span style={{ color: '#004aad' }}>{currentUser?.subscription?.monthlyPriceText}</span></>
												)}
											</Text>
										</div>
										<FiChevronDown className="px-caret" />
									</div>
								</Dropdown>
							) : (
								<a
									data-bs-toggle="modal"
									className="btn-contact login-register"
									onClick={handleLogin}
									role="button"
									aria-label="Login / Register"
								>
									Login/Register
								</a>
							)}
						</div>
					</div>
				</div>
			</header>

			<style>{`
        /* Core layout */
        .px-header {
          display:flex; align-items:center; gap:10px;
        }

		 @media (max-width: 768px) {
    #header .logo { padding: 10px; display: none !important; }
	.login-register {
	margin-top: 5px;
	margin-bottom: 5px;
	font-size: 12px;
	}
  }

        /* Desktop: normal order (menu hidden slot doesn't matter) */
		@media (min-width: 1024px) {
			.mm-slot {
				display: none !important;
			}
		}

        .nav-wrap { margin-left: 5px; }

        /* Logo sizing */
        .px-logo { width: 40%; height: auto; }
        @media (max-width: 768px) {
          .px-logo { width: 100%; max-width: 200px; }
        }

        /* MOBILE layout: left = hamburger, center = logo, right = auth */
        @media (max-width: 992px) {
          /* hide desktop mainnav */
          #mainnav { display: none !important; }

          /* only show the MobileMenu's button INSIDE header */
          .mm-btn { display: none !important; }
          #header .header-inner .mm-btn { display: inline-flex !important; }

          /* reorder */
          .px-header { justify-content: space-between; }
          .mm-slot { order: 1; margin-top: -5px }
          #header .logo { order: 2; flex: 1; text-align: center; }
          .header-right { order: 3; display:flex; align-items:center; }
        }

        /* Kill any theme-provided duplicate hamburgers */
        @media (max-width: 992px) {
          .btn-menu, .mobile-nav-toggler, .mobile-button { display: none !important; }
        }
        @media (min-width: 993px) {
          /* hide MobileMenu button on desktop */
          #header .header-inner .mm-btn { display: none !important; }
        }

        /* User chip (shrinks gracefully on mobile) */
        .px-userchip {
          display: inline-flex; align-items: center; gap: 10px;
          padding: 6px 10px;
          border: 1px solid rgba(0,0,0,.08);
          border-radius: 999px; background: #fff;
          transition: box-shadow .18s ease, transform .18s ease, border-color .18s ease;
          cursor: pointer; user-select: none;
        }
        .px-userchip:hover {
          box-shadow: 0 10px 24px rgba(2,6,23,.08);
          border-color: rgba(0,0,0,.12);
          transform: translateY(-1px);
        }
        .px-usertext { max-width: 220px; display: flex; flex-direction: column; line-height: 1.1; }
        .px-username { font-size: 13px; }
        .px-useremail { font-size: 12px; }
        .px-caret { opacity: .6; }

        /* Compact mode: keep avatar/dropdown visible on mobile */
        @media (max-width: 768px) {
          .header-right { margin-right: -15px !important; padding-top: 5px; padding-bottom: 5px; }
        }
      `}</style>
		</>
	);
}
